import Gallery from 'react-grid-gallery'
import PropTypes from 'prop-types'
import React from 'react'
import shuffleArray from 'shuffle-array'

class PhotosShopPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            images: this.props.images
        }
    }

    render() {
        return (
          <div className='photoGalleries'>
            <h2>Photo Gallery - 駄菓子屋</h2>
            <ul className="breadcrumb">
              <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
                <a href="/" itemProp="url">
                  <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
                </a>
              </li>
              <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
                <span itemProp="title"> <i className="fas fa-caret-right"></i> <i className="fas fa-images"></i> Photo Gallery - 駄菓子屋</span>
              </li>
            </ul>
            <div style={{
                display: "block",
                minHeight: "1px",
                width: "100%",
                border: "1px solid #ddd",
                overflow: "auto",
                textAlign: "center",
                background: "white"
            }}>
              <Gallery
                  images={this.state.images}
                  enableImageSelection={false}
              />
            </div>
          </div>
        )
    }
}

PhotosShopPage.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string.isRequired,
            thumbnail: PropTypes.string.isRequired,
            srcset: PropTypes.array,
            caption: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element
            ]),
            thumbnailWidth: PropTypes.number.isRequired,
            thumbnailHeight: PropTypes.number.isRequired,
            isSelected: PropTypes.bool
        })
    ).isRequired
}

PhotosShopPage.defaultProps = {
    images: shuffleArray([
        {
            src: "https://sharehome.biz/images/shop08.jpg",
            thumbnail: "https://sharehome.biz/images/shop08.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "駄菓子屋の開業前の様子",
            thumbnailCaption: "駄菓子屋の開業前の様子"
        },
        {
          src: "https://sharehome.biz/images/shop03.jpg",
          thumbnail: "https://sharehome.biz/images/shop03.jpg",
          thumbnailWidth: 240,
          thumbnailHeight: 320,
          caption: "駄菓子商品を仕入れました",
          thumbnailCaption: "駄菓子商品を仕入れました"
        },
        {
          src: "https://sharehome.biz/images/shop04.jpg",
          thumbnail: "https://sharehome.biz/images/shop04.jpg",
          thumbnailWidth: 320,
          thumbnailHeight: 240,
          caption: "駄菓子商品をAirレジに登録",
          thumbnailCaption: "駄菓子商品をAirレジに登録"
        },
        {
          src: "https://sharehome.biz/images/shop05.jpg",
          thumbnail: "https://sharehome.biz/images/shop05.jpg",
          thumbnailWidth: 240,
          thumbnailHeight: 320,
          caption: "駄菓子を陳列",
          thumbnailCaption: "駄菓子を陳列"
        },
        {
          src: "https://sharehome.biz/images/shop06.jpg",
          thumbnail: "https://sharehome.biz/images/shop06.jpg",
          thumbnailWidth: 240,
          thumbnailHeight: 320,
          caption: "駄菓子屋の案内をブラックボードに書き込みました",
          thumbnailCaption: "駄菓子屋の案内をブラックボードに書き込みました"
        },
        {
          src: "https://sharehome.biz/images/shop07.jpg",
          thumbnail: "https://sharehome.biz/images/shop07.jpg",
          thumbnailWidth: 320,
          thumbnailHeight: 240,
          caption: "駄菓子屋の正面",
          thumbnailCaption: "駄菓子屋の正面"
        }
    ])
}

export default PhotosShopPage


// WEBPACK FOOTER //
// ./src/PhotosShopPage.js